export const USE_GENERAL_AI_KNOWLEDGE = 'use-general-ai-knowledge';
export const USE_ROVO_ORGANISATION_KNOWLEDGE = 'use-rovo-organisation-knowledge';
export const TELL_AI = 'tell-ai';
export const TELL_AGENT = 'tell-agent';
export const BROWSE_AGENTS = 'agent:browse-more-agents';
export const SHOW_MORE = 'show-more';
export const UI_SCROLL_MARGIN_TOP = 32;
